/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Copy_LinkInputs */

const en_directory_submit_enrich_copy_link = /** @type {(inputs: Directory_Submit_Enrich_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

const zh_directory_submit_enrich_copy_link = /** @type {(inputs: Directory_Submit_Enrich_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制链接`)
};

/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Directory_Submit_Enrich_Copy_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_copy_link = /** @type {((inputs?: Directory_Submit_Enrich_Copy_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Copy_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_copy_link(inputs)
	return zh_directory_submit_enrich_copy_link(inputs)
});
export { directory_submit_enrich_copy_link as "directory.submit.enrich.copy_link" }